import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import MotionDiv from "../motionDiv";

function HotlineBlock() {

    return (
        <section id="hotline" className="about-section-two style-two layout-pt-60 js-tab-menu-content backgroundBlue">
            <div className="auto-container">
                <Row>
                    <Col lg={6} md={6} sm={12}>
                        <Col lg={12}>
                            <MotionDiv delay={0.3}>
                            <div className="sec-title">
                                <h2>
                                    <span>Hotline</span> Talents Handicap
                                </h2>
                                <h3>Un soutien expert et personnalisé de vos collaborateurs</h3>
                            </div>
                            </MotionDiv>
                        </Col>
                        <Col lg={12}>
                            <MotionDiv delay={0.5} classes="text">
                                <p>
                                    Un service pour <span>soutenir vos collaborateurs, valoriser votre engagement</span> de manière
                                    concrète et <span>favoriser l’engagement de l’ensemble de vos collaborateurs.</span>
                                    <br/>
                                    <br/>
                                    Fourni clés en main, il comprend <span>un espace web dédié et personnalisé</span> pour offrir à vos
                                    collaborateurs l’accès au service et à ses ressources, permettant :
                                    <br/>
                                    <br/>
                                </p>
                                    <ul className={'hotline-list'}>
                                        <li>
                                            La <span>prise de rendez-vous avec nos experts</span> qui répondent aux questions de vos collaborateurs,
                                            les accompagnent et échangent avec eux de manière confidentielle, individuelle et personnalisée
                                        </li>
                                        <li>
                                            L’<span>accès à vos informations utiles</span> (votre politique handicap, contacts...)
                                        </li>
                                        <li>
                                            L’accès à des <span>ressources utiles sur le handicap et l’inclusion</span> (témoignages, articles, webinaires...)
                                        </li>
                                        <li>
                                            L’accès à une <span>foire aux questions personnalisée (FAQ)</span> avec les réponses aux questions fréquentes
                                        </li>
                                        <li>
                                            D’envoyer des demandes d’information à travers un formulaire de contact
                                        </li>
                                    </ul>
                                <p>
                                    <br/>
                                    Un kit de communication vous est fourni pour faciliter votre communication interne et informer vos collaborateurs
                                </p>
                                <div className={'d-flex justify-content-center justify-content-sm-start'}>
                                    <Link to="https://hotline.talents-handicap.com/" target="_blank"
                                          className="theme-btn btn-style-one mt-3 mb-3 small">
                                        Découvrir la Hotline Talents Handicap
                                    </Link>
                                </div>
                            </MotionDiv>
                        </Col>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                        <MotionDiv delay={0.4} duration={0.5}>
                            <figure className="section-picture">
                                <img src="/images/homepage/hotline-handicap-entreprise.webp"
                                     alt="Conseillère hotline sensibilisation handicap entreprise souriante" className={"flip"}/>
                            </figure>
                        </MotionDiv>
                    </Col>

                </Row>
            </div>
        </section>
    )
}

export default HotlineBlock;
